import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'automation' },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "automation" */ './views/list')
          ),
        meta: {
          breadcrumbKey: 'workflow',
        },
      },
      {
        path: 'workflow-test',
        name: `${routeNamePrefix}.test`,
        component: () =>
          lazyLoadView(
            import(
              /* webpackChunkName: "automation" */ './views/WorkflowTestView'
            )
          ),
        meta: {
          breadcrumbKey: 'workflow',
        },
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "automation" */ './views/create')
          ),
        meta: {},
      },
      // {
      //   path: ':moduleName/:id/execution-log',
      //   name: `${routeNamePrefix}.execution-log`,
      //   component: () =>
      //     lazyLoadView(
      //       import(
      //         /* webpackChunkName: "automation" */ './components/execution-log/list'
      //       )
      //     ),
      // },
      // {
      //   path: ':moduleName/:id/execution-log/:logId',
      //   name: `${routeNamePrefix}.execution-log-view`,
      //   component: () =>
      //     lazyLoadView(
      //       import(
      //         /* webpackChunkName: "automation" */ './components/execution-log/view'
      //       )
      //     ),
      // },
      {
        path: ':moduleName/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "automation" */ './views/edit')
          ),
        meta: {},
      },
    ],
  },
]
